import { useEffect, useRef } from 'react'

import { logger } from '../logger'

export function useWhyDidYouUpdate(
  name: string,
  props: Record<string, unknown>
): void {
  const previousProps = useRef<any>()

  useEffect(() => {
    if (previousProps.current) {
      const allKeys = Object.keys({
        ...(previousProps.current as Record<string, unknown>),
        ...props,
      })

      const changesObj = allKeys.reduce((previousChanges, key): Record<
        string,
        unknown
      > => {
        const currentChanges = { ...previousChanges }
        if (
          previousProps.current &&
          previousProps.current[key] !== props[key]
        ) {
          currentChanges[key] = {
            from: previousProps.current[key],
            to: props[key],
          }
        }

        return currentChanges
      }, {} as Record<string, unknown>)

      if (
        Object.keys(changesObj).length &&
        process.env.JEST_WORKER_ID === undefined
      ) {
        logger.info('❓ [why-did-you-update]', name, changesObj)
      }
    }

    previousProps.current = props
  })
}
